import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import { MediaFormatEnum } from '../../../../modules/general-settings/enums/mediaFormat.enum';
import ProductAvatarRenderer from '../../../../modules/products/ProductAvatarRenderer';
import { useProductsAddedCardStyles } from '../productsAddedCard.styles';
import { ProductsAddedCardItem as ProductsAddedCardItemData } from '../productsAddedCard.types';

const COLOR_DOT_SIZE = 12;
const PRODUCT_TEXT_MAX_WIDTH = 210;

interface ProductsAddedCardItemProps {
  item?: ProductsAddedCardItemData;
  mediaFormat: MediaFormatEnum;
  height: number;
}

const ProductsAddedCardItem = ({ item, mediaFormat, height }: ProductsAddedCardItemProps) => {
  const { classes } = useProductsAddedCardStyles({ mediaFormat });

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexShrink: 0,
        width: '100%',
        height,
        borderRadius: '8px',
        border: `1px solid ${theme.palette.custom.border.primary}`,
        overflow: 'hidden',
      })}
    >
      <Box sx={{ flexShrink: 0, marginRight: 1 }}>
        <ProductAvatarRenderer
          url={item?.imageUrl}
          className={classes.avatarContainer}
          style={{ height }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 0.5,
          minWidth: 0,
          height,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            noWrap
            variant="body2"
            color="textPrimary"
            title={item?.name}
            sx={{ maxWidth: PRODUCT_TEXT_MAX_WIDTH }}
          >
            {item?.name}
          </Typography>
          <Typography
            noWrap
            variant="micro1"
            color="text.secondary"
            title={item?.code}
            sx={{ maxWidth: PRODUCT_TEXT_MAX_WIDTH }}
          >
            {item?.code}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
          <Box
            sx={(theme) => ({
              width: COLOR_DOT_SIZE + 2,
              height: COLOR_DOT_SIZE + 2,
              flexShrink: 0,
              borderRadius: '50%',
              backgroundColor: item?.colorHex,
              border: `1px solid ${theme.palette.custom.border.primary}`,
            })}
          />
          <Typography noWrap variant="micro1" color="text.secondary" className={classes.colorName}>
            {item?.colorName || ''}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductsAddedCardItem;
